module.exports = __webpack_public_path__ + "img/nirmaan_trans_logo.5c8ef331.png";